import React from 'react';
import { history } from '../../../_helpers';
import Admin from '../../../_pages/Admin/index.jsx';
import DashBoardReport from '../../../_pages/DashBoard/index'


const Authorization = (allowedRoles) =>
  (WrappedComponent, permissions) => {
    return class WithAuthorization extends React.Component {

      render() {

        const userType = localStorage.getItem('usertype');
        const isAdmin = userType.includes('super_admin') || userType.includes('seller_admin') || userType.includes('organisation_admin')

        if (allowedRoles.includes(permissions)) {
          return <WrappedComponent {...this.props} />
        } else {
          if (userType.includes('participant') && !isAdmin) {
            history.push('/app/dashboard')
            return <DashBoardReport />
          } else {
            history.push('/admin/app/dashboard')
            return <Admin />
          }
        }
      }

    }
  }
export default Authorization;



// WEBPACK FOOTER //
// ./src/_components/common/Authorization/index.jsx